// Renders a table of the user account roles
import { useDispatch, useSelector } from "react-redux"
import {
  removeRoleFromUserAccount,
  selectUserAccountsById,
  selectUserAccountsRoles,
} from "./slice"
import Paper from "../../ui/Paper"
import Table, { Cell, Row } from "../../ui/Table"
import TableHeaderRow from "../../ui/TableHeaderRow"
import TableHeader from "../../ui/TableHeader"
import DeleteConfirmationDialog from "../../ui/DeleteConfirmationDialog"
import PropTypes from "prop-types"
import React from "react"
import Authed from "./Authed"
import ErrorMsg from "../../ui/ErrorMsg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Text from "../../ui/Text"
import styled from "styled-components"

const RoleName = styled.span`
  color: ${(props) => props.color};
`

const RolesTable = ({ id, roles = [] }) => {
  const dispatch = useDispatch()
  // const advancedMode = useSelector(selectAdvancedMode)
  const accountsByID = useSelector(selectUserAccountsById)
  const account = accountsByID[id]
  const onDelete = (id, role) => {
    dispatch(removeRoleFromUserAccount({ id, ...role }))
  }

  const roleDefs = useSelector(selectUserAccountsRoles)

  return (
    <Paper>
      {account?._saveStatus == "rejected" && (
        <ErrorMsg
          msg={
            account._errorMessage ||
            "an error occurred removing a role (NOTE a user must have at least 1 role)"
          }
          showIcon={true}
        />
      )}
      <Table>
        <TableHeaderRow>
          <TableHeader></TableHeader>
          <TableHeader>Assigned role</TableHeader>
          <TableHeader>Description</TableHeader>
          <TableHeader>Scope</TableHeader>
          {/*Actions*/}
          <TableHeader />
        </TableHeaderRow>
        <tbody>
          {roles.map((role, i) => (
            <Row key={i} zebra>
              <Cell>
                <RoleName color={roleDefs[role.role]?.colorCode}>
                  <FontAwesomeIcon icon={roleDefs[role.role]?.icon} />
                </RoleName>
              </Cell>
              <Cell>
                <RoleName color={roleDefs[role.role]?.colorCode}>
                  {role.role}
                </RoleName>
              </Cell>
              <Cell>
                <Text small>{roleDefs[role.role]?.description || "-"}</Text>
              </Cell>
              <Cell>{role.ctx || "global"}</Cell>
              <Cell>
                <Authed allowRoles={["admin"]}>
                  <DeleteConfirmationDialog
                    item={{
                      name: `role ${role.role} in organisation ${
                        role.ctx || "none"
                      }`,
                    }}
                    onDelete={() => onDelete(id, role)}
                    iconOnly
                  />
                </Authed>
              </Cell>
            </Row>
          ))}
        </tbody>
      </Table>
    </Paper>
  )
}

RolesTable.propTypes = {
  id: PropTypes.string,
  roles: PropTypes.array,
}

export default RolesTable
